var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-text-heading-xxs lg:fe-text-heading-xs"},[_vm._v(" Questions & Answers ")])
}
var staticRenderFns = []

export { render, staticRenderFns }